up.compiler(".up_cancel", function (element) {
  const dismissButton = document.querySelector("up-drawer-dismiss");
  const redirect_to = element.dataset.redirect;
  function theCallback() {
    if (dismissButton) {
      setTimeout(() => {
        dismissButton.click();
      }, 100);
    } else {
      window.location.href = redirect_to;
    }
  }
  element.addEventListener("click", theCallback);
  return () => {
    element.removeEventListener("click", theCallback);
  };
});
